import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const RichTextBlock = ({ text }) => (
  <div className="copy max-w-3xl mx-auto my-8">
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
  </div>
);

export default RichTextBlock;
